import { NotificationPermission } from './types'

export const isNotificationPromptDue = (): boolean => false

export const readNotificationPermission = async (): Promise<NotificationPermission> => 'granted'

export const requestNotificationPermission = async (): Promise<NotificationPermission> => 'granted'

export const startNotifications = async () => {}

export const removeNotificationListeners = () => {}
